<template>
  <div class="dashboard">
    <div class="dashboardSideBar">
      <div class="dashboardSideBarWrapper">
        <router-link tag="div" :to="{name: 'balancehistory'}" class="dashboardSideBarWrapper__adx-balance">
          <div class="dashboardSideBarWrapper__adx-balance__title">ADX Balance:</div>
          <div class="dashboardSideBarWrapper__adx-balance__value">{{finalBalance | formatMoney}}</div>
        </router-link>
      </div>
      <sidebar-menu />
    </div>
    <div class="dashboard__main container-router">
      <router-view />
    </div>
  </div>
</template>

<script>
import SideBar from "@/components/SideBar/Desktop"

import { mapGetters } from 'vuex'

export default {
  name: `adx-dashboard`,
  components: {
    'sidebar-menu': SideBar
  },
  data() {
    return {
      adxBalance: 15000000
    }
  },
  computed: {
    ...mapGetters ({
      finalBalance: 'finalBalance'
    }),
  },
  mounted() {
    (async () => {
      await this.$store.dispatch(`getFinalBalance`)
    })();
  }
}
</script>

<style lang="scss">
@import "./index.scss";
</style>
